<template>
  <div class="mb-3">
    <div v-if="accomodations.data && accomodations.data.length" class="flex flex-wrap gap-5 justify-center">
      <div v-for="(item, index) in accomodations.data" :key="index" class="
          relative
          overflow-hidden
          rounded-xl
          w-full
          sm:w-[calc(50%-10px)]
          md:w-[calc(33.333%-14px)]
          lg:w-[calc(25%-15px)]
          h-[25vh]
          hover:scale-[1.05]
          transition
        ">
        <a @click="goToItem(item.slug)" class="block h-full w-full">
          <div class="room-thumb relative h-full w-full">

            <image_slider :sliderImage="item.slider_preview" :imageWidth="400" :slideInterval="5000" />

            <!-- Overlay -->
            <div class="absolute inset-0 flex items-end p-4 bg-gradient-to-t from-black/60 to-transparent">
              <div class="text-white">
                <h5 class="font-semibold text-base leading-tight">
                  {{ item.name }}
                </h5>

                <span class="text-sm opacity-90">
                  {{ item.city }}
                  <template v-if="item.state && item.state !== item.city">
                    , {{ item.state }}
                  </template>
                </span>
              </div>
            </div>

            <!-- Sponsored Badge -->
            <a v-if="item.promotion" :href="$termsUrl + '#sponsored'" target="_blank" class="
                absolute
                left-2
                top-2
                bg-black/50
                backdrop-blur-sm
                p-2
                rounded-full
                text-gray-200
                hover:text-yellow-400
                transition-all
                duration-300
                flex
                items-center
                gap-1
              ">
              <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 576 512" class="w-4 h-4">
                <path
                  d="M309 106c11.4-7 19-19.7 19-34c0-22.1-17.9-40-40-40s-40 17.9-40 40c0 14.4 7.6 27 19 34L209.7 220.6c-9.1 18.2-32.7 23.4-48.6 10.7L72 160c5-6.7 8-15 8-24c0-22.1-17.9-40-40-40S0 113.9 0 136s17.9 40 40 40c.2 0 .5 0 .7 0L86.4 427.4c5.5 30.4 32 52.6 63 52.6H426.6c30.9 0 57.4-22.1 63-52.6L535.3 176c.2 0 .5 0 .7 0c22.1 0 40-17.9 40-40s-17.9-40-40-40s-40 17.9-40 40c0 9 3 17.3 8 24l-89.1 71.3c-15.9 12.7-39.5 7.5-48.6-10.7L309 106z" />
              </svg>
            </a>

          </div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      accomodations: { data: [] },
      currentUrl: window.location.origin,
    };
  },

  props: {
    cache_acco: {
      type: [Array, Object, String],
      required: true
    },
    listingSlug: {
      type: String,
      default: ''
    }
  },

  methods: {
    goToItem(slug) {
      let prefix = this.listingSlug
        ? '/' + this.listingSlug + '/'
        : '/acco/';

      window.location.href = this.$homeUrl + prefix + slug;
    }
  },

  created() {
    this.accomodations.data =
      typeof this.cache_acco === 'string'
        ? JSON.parse(this.cache_acco)
        : this.cache_acco;
  }
};
</script>